import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography, Button } from '@mui/material';
import UploadRow from './UploadRow';
import RestorableUploadRow from './RestorableUploadRow';

const RestorableChequeUploadRow = ({
  chequeFile,
  chequeFileLink,
  onChequeUpload,
  hasNoCheque,
  onCheckboxChange,
  bankDetails,
  onBankDialogOpen,
  onPreview,
  isOptional = false
}) => {
  // Helper function to get file name from cheque link
  const getFileNameFromUrl = (url) => {
    if (!url) return null;
    const urlParts = url.split('/');
    const fileName = urlParts[urlParts.length - 1];
    return fileName.includes('.') ? fileName : 'cancelled-cheque.jpg';
  };

  const renderChequeUpload = () => {
    // If we have a restored file link but no current file, use RestorableUploadRow
    if (chequeFileLink && !chequeFile) {
      return (
        <RestorableUploadRow
          label="Cancelled Cheque"
          file={chequeFile}
          fileLink={chequeFileLink}
          handler={onChequeUpload}
          isOptional={isOptional}
          onPreview={onPreview}
          fileName={getFileNameFromUrl(chequeFileLink)}
        />
      );
    }
    
    // Otherwise use regular UploadRow
    return (
      <UploadRow
        label="Cancelled Cheque"
        file={chequeFile}
        handler={onChequeUpload}
        isOptional={isOptional}
        onPreview={onPreview}
      />
    );
  };

  return (
    <Box>
      {!hasNoCheque && (
        <>
          {renderChequeUpload()}
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Please upload a JPG image of the cancelled cheque.
          </Typography>
        </>
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={hasNoCheque}
            onChange={onCheckboxChange}
          />
        }
        label="I don't have a cancelled cheque, but I have a bank mandate"
        sx={{
          mt: 1,
          '& .MuiFormControlLabel-label': {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            fontStyle: 'italic',
          }
        }}
      />
      {hasNoCheque && bankDetails.ifsc && (
        <Button
          onClick={onBankDialogOpen}
          size="small"
          variant="text"
          sx={{ mt: 1 }}
        >
          View/Edit Bank Details
        </Button>
      )}
    </Box>
  );
};

export default RestorableChequeUploadRow;